import { render, staticRenderFns } from "./ExpiresSessionDialog.vue?vue&type=template&id=8f61537c&"
import script from "./ExpiresSessionDialog.vue?vue&type=script&lang=js&"
export * from "./ExpiresSessionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports